/**
 * 设备的类型的轨计划
 * date：2022 03 24  fuck
 */
export default {
    deviceType: {
        all: '全部',
        sensor: '温/湿度计',
        gateway: '网关路由',
        display: '数字显示屏',
        relay: '中继',
        zbp_1: 'ZigBee温度计',
        zbp_2: 'ZigBee温湿度计',
        lora_1: 'Lora温度计',
        lora_2: 'Lora温湿度计',
        zeta_1: 'Zeta温度计',
        zeta_2: 'Zeta温湿度计',
        gt_1: '网关1.0',
        gt_2: '网关1.0带Gps',
        gt_3: '网关2.0',
        dt_1: '显示屏1.0',
        rt_1: '中继1.0'
    }
};
